module.exports = "<div class=\"row bgHeading\"><h2>Science Fair Far North Committee</h2></div>\n<div class=\"col-12\">\n  <div class=\"col-12\" [innerHtml]=\"body\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/about/about.component.html
// module id = 319
// module chunks = 1